import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import { initFaro } from './faro';

// Initialize Grafana Faro before React mounts so it captures init-time errors.
// No-op when app.observability.faro.url is empty (local dev).
initFaro();

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
